export function HelpHint({ text }: { text: string }) {
  return (
    <p className="mt-1.5 flex items-start gap-1.5 text-xs text-smoke">
      <span className="mt-px inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full bg-gray-200 text-[9px] font-bold text-smoke">
        i
      </span>
      {text}
    </p>
  );
}
